import { styled } from "@mui/system";
import { Box } from "@mui/material";

import { palette } from "../../styles/palette";

const Legend = styled(Box)({
    bottom: "10px",
    left: "20%",
    position: "absolute",
    zIndex: "100",
    display: "flex",
});

const ItemContainer = styled(Box)({
    width: "30px",
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  });

const StyledBox = styled(Box)({
    display: "inline-block",
    height: "13px",
    width: "13px",
    border: `1px solid ${palette.typography.black.inactive}`,
  });


const Text = styled("p")({
    color: palette.typography.white.high,
    fontSize: "12px",
    paddingTop: "5px",
  });

export const HeatmapLegend = () => {
  const heatmapMapping = {
    50: palette.heatmap[0],
    100: palette.heatmap[1],
    150: palette.heatmap[2],
    200: palette.heatmap[3],
    250: palette.heatmap[4],
    "250+": palette.heatmap[5],
  };

  return (
    <Legend>
      {Object.keys(heatmapMapping).map((value, index) => (
        <ItemContainer key={index}>
          <StyledBox
            style={{ backgroundColor: heatmapMapping[value] }}
          />
          <Text>{value}</Text>
        </ItemContainer>
      ))}
    </Legend>
  );
};
